import React from "react";
import InternalLink from "components/InternalLink";
import { Button, Link } from "mondrian-react";

const analyticsBase = {
  "data-gtm-event-category": "minha-claro:meu-perfil",
};

export default function MobileMenu({
  isOpen,
  onClose,
  onLogout,
  onPassword,
}) {
  return (
    <ul
      className={`cred-MobileMenuPanel${
        isOpen ? " cred-MobileMenuPanel--open" : ""
      }`}
      id="cred-MobileMenuPanel"
    >
      <li className="cred-MobileMenuItem">
        <InternalLink
          {...analyticsBase}
          className="cred-MobileMenuAction"
          data-gtm-event-action="clique:link"
          data-gtm-event-label="meu-perfil"
          link="/meuperfil"
          onClick={onClose}
        >
          <span
            aria-hidden="true"
            className="mdn-Icon-minha-claro mdn-Icon--md cred-MobileMenuIcon"
          ></span>
          Meu Perfil
        </InternalLink>
      </li>
      <li className="cred-MobileMenuItem">
        <InternalLink
          {...analyticsBase}
          className="cred-MobileMenuAction"
          data-gtm-event-action="clique:menu-header"
          data-gtm-event-label="alterar-email"
          link="/meuperfil/alterar-email"
          onClick={onClose}
        >
          <span
            aria-hidden="true"
            className="mdn-Icon-e-mail mdn-Icon--md cred-MobileMenuIcon"
          ></span>
          Alterar E-mail
        </InternalLink>
      </li>
      <li className="cred-MobileMenuItem">
        <InternalLink
          {...analyticsBase}
          className="cred-MobileMenuAction"
          data-gtm-event-action="clique:menu-header"
          data-gtm-event-label="alterar-senha"
          link="#"
          onClick={onPassword}
        >
          <span
            aria-hidden="true"
            className="mdn-Icon-senha mdn-Icon--md cred-MobileMenuIcon"
          ></span>
          Alterar Senha
        </InternalLink>
      </li>
      <li className="cred-MobileMenuItem">
        <InternalLink
          {...analyticsBase}
          className="cred-MobileMenuAction"
          data-gtm-event-action="clique:menu-header"
          data-gtm-event-label="acesso-pelo-celular"
          link="/meuperfil/acesso-pelo-celular"
          onClick={onClose}
        >
          <span
            aria-hidden="true"
            className="mdn-Icon-solar-ache-aqui mdn-Icon--md cred-MobileMenuIcon"
          ></span>
          Acesso pelo celular
        </InternalLink>
      </li>
      <li className="cred-MobileMenuItem">
        <Link
          inline
          {...analyticsBase}
          className="cred-MobileMenuAction"
          data-gtm-event-action="clique:menu-header"
          data-gtm-event-label="minha-claro"
          href="https://minhaclaro.claro.com.br/"
          onClick={onClose}
          rel="noopener noreferrer"
          target="_blank"
        >
          <span
            aria-hidden="true"
            className="mdn-Icon-claro mdn-Icon--md cred-MobileMenuIcon"
          ></span>
          Minha Claro
        </Link>
      </li>
      <li className="cred-MobileMenuItem">
        <Link
          inline
          {...analyticsBase}
          className="cred-MobileMenuAction"
          data-gtm-event-action="clique:menu-header"
          data-gtm-event-label="minha-claro-tv"
          href="https://www.clarotvmais.com.br/home-landing"
          onClick={onClose}
          rel="noopener noreferrer"
          target="_blank"
        >
          <span
            aria-hidden="true"
            className="mdn-Icon-tv mdn-Icon--md cred-MobileMenuIcon"
          ></span>
          Minha Claro TV (Claro TV+)
        </Link>
      </li>
      <li className="cred-MobileMenuItem">
        <Button
          {...analyticsBase}
          className="cred-MobileMenuAction"
          data-gtm-event-action="clique:menu-header"
          data-gtm-event-label="sair"
          onClick={onLogout}
          type="button"
        >
          <span
            aria-hidden="true"
            className="mdn-Icon-sair mdn-Icon--md cred-MobileMenuIcon"
          ></span>
          Sair
        </Button>
      </li>
    </ul>
  );
}
